'use client';

import LoadingSpinner from '@umodeapporg/ui/components/UI/LoadingSpinner';
import NoDataFound from '@umodeapporg/ui/components/UI/NoDataFound';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface EstadoDoBlocoProps {
  loading: boolean;
  /** Falhou: o bloco diz o que faltou e oferece pedir de novo, nunca um zero tranquilo. */
  failed: boolean;
  /**
   * Carregou e não há nada para responder (nenhuma célula de costura, por exemplo). O
   * bloco cujo vazio já tem mensagem própria, como o risco zerado, não passa nada aqui.
   */
  vazio?: boolean;
  vazioTexto?: string;
  onRetry: () => void;
  children: ReactNode;
}

/**
 * Os três estados que todo bloco desta tela tem antes de ter uma resposta. Um bloco falha
 * sozinho: a Visão executiva lê duas fontes (a carteira e a grade do Mapa), e quando uma
 * delas cai os outros blocos continuam valendo.
 */
export function EstadoDoBloco({
  loading,
  failed,
  vazio = false,
  vazioTexto,
  onRetry,
  children,
}: EstadoDoBlocoProps) {
  const { t } = useTranslation('common');

  if (loading) {
    return (
      <div className="flex flex-1 items-center justify-center py-8">
        <LoadingSpinner size={5} color="foreground-faint" />
      </div>
    );
  }

  if (failed) {
    return (
      <NoDataFound
        variant="error"
        size="sm"
        title={t('visaoExecutiva.erroTitulo')}
        description={t('visaoExecutiva.erroDescricao')}
        action={{ label: t('visaoExecutiva.tentar'), onClick: onRetry, icon: 'refresh' }}
      />
    );
  }

  if (vazio) {
    return <NoDataFound variant="empty" size="sm" icon="inbox" title={vazioTexto} />;
  }

  return <>{children}</>;
}
